import React from 'react';
import { Box, Typography } from '@mui/material';

import { MerchantAwareLink } from '../../../components/core/MerchantAwareLink';
import type { StoreReadiness } from '../../../store/modules/merchant/types';
import { getPendingStoreReadinessItems } from '../storeReadiness';
import { useProvisioningPlatform } from '../provisioning';
import { AgentHubWarningBanner } from './AgentHubWarningBanner';

const linkSx = {
  display: 'inline',
  color: 'warning.dark',
  fontWeight: 700,
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
};

type Props = {
  storeReadiness?: StoreReadiness | null;
};

export const AgentStoreReadinessNotice = ({ storeReadiness }: Props): JSX.Element | null => {
  const { requiresProvisioning } = useProvisioningPlatform();
  const pendingItems = getPendingStoreReadinessItems(storeReadiness, {
    hasProvisioning: requiresProvisioning,
  });
  if (pendingItems.length === 0) {
    return null;
  }

  return (
    <AgentHubWarningBanner testId="ella-agent-store-readiness-notice">
      <Box>
        Agent is not able to go live until pending requirements are complete.
        <Box
          component="ul"
          sx={{
            m: 0,
            mt: 1,
            pl: 2.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          {pendingItems.map((item) => (
            <Box component="li" key={item.id} sx={{ lineHeight: '18px' }}>
              <Typography
                component={MerchantAwareLink}
                to={item.path}
                data-testid={`ella-agent-store-readiness-link-${item.id}`}
                sx={linkSx}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </AgentHubWarningBanner>
  );
};
